import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "font" }
const _hoisted_2 = { class: "pt-6 font" }
const _hoisted_3 = { class: "pt-6 font" }
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.nurseryName), 1),
      _createElementVNode("h3", null, _toDisplayString(_ctx.yearMonth), 1),
      _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Petty Cash Book", -1))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h5", null, "Account Titles", -1)),
      _createVNode(_component_v_table, {
        class: "pt-1 font",
        density: "compact"
      }, {
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { style: {"width":"34%"} }, "Account"),
              _createElementVNode("th", { style: {"width":"33%"} }, "Income Total"),
              _createElementVNode("th", { style: {"width":"33%"} }, "Expense Total")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountTitles, (item, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", null, _toDisplayString(item.name), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.getIncomebyAccountTitle(item.titleId)), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.getOutgobyAccountTitle(item.titleId)), 1)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[7] || (_cache[7] = _createElementVNode("h5", null, "Ledger", -1)),
      _createVNode(_component_v_table, {
        class: "pt-1",
        density: "compact"
      }, {
        default: _withCtx(() => [
          _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "No."),
              _createElementVNode("th", null, "Date"),
              _createElementVNode("th", null, "Account"),
              _createElementVNode("th", null, "Description"),
              _createElementVNode("th", null, "Supplier"),
              _createElementVNode("th", null, "Income"),
              _createElementVNode("th", null, "Expense"),
              _createElementVNode("th", null, "Balance"),
              _createElementVNode("th", null, "Tax"),
              _createElementVNode("th", null, "Notes")
            ])
          ], -1)),
          (_ctx.cashbook)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_4, [
                _createElementVNode("tr", null, [
                  _cache[3] || (_cache[3] = _createElementVNode("td", null, "Withdrawal", -1)),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                    return _createElementVNode("td", { key: i }, "-")
                  }), 64)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.cashbook.carriedAmount), 1),
                  _cache[4] || (_cache[4] = _createElementVNode("td", null, "-", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.cashbook.carriedAmount), 1),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (i) => {
                    return _createElementVNode("td", {
                      key: i + 4
                    }, "-")
                  }), 64))
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cashbook.details, (item, i) => {
                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                    _createElementVNode("td", null, _toDisplayString(i + 1), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatMonthDay(item.date)), 1),
                    _createElementVNode("td", null, _toDisplayString(item.title ? item.title.name : "-"), 1),
                    _createElementVNode("td", null, _toDisplayString(item.description || "-"), 1),
                    _createElementVNode("td", null, _toDisplayString(item.supplier || "-"), 1),
                    _createElementVNode("td", null, _toDisplayString(item.incomeAmount), 1),
                    _createElementVNode("td", null, _toDisplayString(item.outgoAmount), 1),
                    _createElementVNode("td", null, _toDisplayString(item.incomeAmount - item.outgoAmount), 1),
                    _createElementVNode("td", null, _toDisplayString(item.taxation
                    ? _ctx.taxationOptions.find((t) => t.value == item.taxation).text
                    : "-"), 1),
                    _createElementVNode("td", null, _toDisplayString(item.note || "-"), 1)
                  ]))
                }), 128)),
                _createElementVNode("tr", null, [
                  _cache[5] || (_cache[5] = _createElementVNode("td", null, "Total", -1)),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                    return _createElementVNode("td", { key: i }, "-")
                  }), 64)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.cashbook.totalIncomeAmount), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.cashbook.totalOutgoAmount), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.cashbook.remainingAmount), 1),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (i) => {
                    return _createElementVNode("td", {
                      key: i + 4
                    }, "-")
                  }), 64))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider)
    ])
  ]))
}